export default "__VITE_ASSET__Bce_JU1S__"